module.exports = __webpack_public_path__ + "img/p4.64500fd4.png";